import { useQuery } from '@tanstack/react-query';
import { sendValidationMessage } from './sendSocureValidationMessage.api';

export const useSendValidationMessage = (customerId: string) =>
  useQuery({
    queryFn: () => sendValidationMessage(customerId),
    queryKey: ['sendValidationMessage', customerId],
    enabled: false,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
